import { AuthError, PostgrestError } from "@supabase/supabase-js";
import * as Sentry from "@sentry/react";

interface ErrorContext {
    operation?: string;
    additionalData?: Record<string, any>;
}

export const supabaseReportException = (error: PostgrestError, context?: ErrorContext) => {
  if (import.meta.env.PROD) {
    Sentry.withScope((scope) => {
      scope.setTag("error_type", "supabase_error");

      if (context?.operation) {
        scope.setTag("operation", context.operation);
      }

      if (context?.additionalData) {
        scope.setExtras(context.additionalData);
      }

      const errorDetails = {
        code: error.code,
        details: error.details,
        hint: error.hint,
        message: error.message,
      };

      scope.setContext("error_details", errorDetails);
      Sentry.captureException(new Error(`Supabase Error: ${error.message}`));
    });
  } else {
    console.error("[Supabase Error]", error.message, {
      code: error.code, details: error.details, hint: error.hint, ...context,
    });
  }
};

export const supabaseAuthReportException = (error: AuthError, context?: ErrorContext) => {
  if (import.meta.env.PROD) {
    Sentry.withScope((scope) => {
      scope.setTag("error_type", "supabase_auth_error");

      if (context?.operation) {
        scope.setTag("operation", context.operation);
      }

      if (context?.additionalData) {
        scope.setExtras(context.additionalData);
      }

      scope.setContext("error_details", {
        message: error.message,
        status: error.status,
      });
      Sentry.captureException(new Error(`Supabase Auth Error: ${error.message}`));
    });
  } else {
    console.error("[Supabase Auth Error]", error.message, { status: error.status, ...context });
  }
};

export const supabaseStorageReportException = (error: string, context?: ErrorContext) => {
  if (import.meta.env.PROD) {
    Sentry.withScope((scope) => {
      scope.setTag("error_type", "supabase_storage_error");

      if (context?.operation) {
        scope.setTag("operation", context.operation);
      }

      if (context?.additionalData) {
        scope.setExtras(context.additionalData);
      }

      Sentry.captureException(new Error(`Supabase Storage Error: ${error}`));
    });
  } else {
    console.error("[Supabase Storage Error]", error, context);
  }
};

export const generalReportException = (error: Error, context?: ErrorContext) => {
  if (import.meta.env.PROD) {
    Sentry.withScope((scope) => {
      scope.setTag("error_type", "general_error");

      if (context?.operation) {
        scope.setTag("operation", context.operation);
      }

      if (context?.additionalData) {
        scope.setExtras(context.additionalData);
      }

      Sentry.captureException(error);
    });
  } else {
    console.error("[General Error]", error.message, context);
  }
};

export const reportLog = (message: string) => {
  if (import.meta.env.PROD) {
    // Sentry.addBreadcrumb({
    //   category: "log",
    //   message,
    //   level: "info",
    // });
  } else {
    console.log("[Log]", message);
  }
};
